<div class="bg-white rounded-lg border border-gray-100 shadow-sm p-4">
  <h3 class="text-base font-bold text-gray-800 tracking-tight mb-1">
    Kalenderabo
    <span class="ml-1 align-middle text-xs font-semibold text-yellow-700 bg-yellow-50 rounded-full px-2 py-0.5">Preview</span>
  </h3>
  <p class="text-sm text-gray-500 mb-4" data-testid="calendar-helper-text">{{ helperText() }}</p>

  @if (loadFailed()) {
    <p class="mb-3 rounded-xl bg-red-50 px-3 py-2 text-sm font-medium text-red-700" role="alert"
       data-testid="calendar-load-error">
      Der Status des Kalenderlinks konnte nicht geladen werden.
      <button (click)="load()" class="ml-1 font-semibold underline hover:no-underline" type="button">
        Erneut versuchen
      </button>
    </p>
  }

  <div class="flex flex-wrap items-center gap-2">
    <button (click)="copyLink()" [disabled]="loading()"
            class="inline-flex items-center gap-2 rounded-lg border-2 border-gray-200 bg-white px-5 py-2 text-sm font-semibold text-gray-700 transition-all duration-200 hover:bg-gray-50 active:scale-95 disabled:cursor-not-allowed disabled:opacity-50"
            data-testid="calendar-copy-link" type="button">
      <svg class="h-4 w-4" height="16" viewBox="0 0 256 256" width="16" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path
          d="M216 28H88a12 12 0 0 0-12 12v36H40a12 12 0 0 0-12 12v128a12 12 0 0 0 12 12h128a12 12 0 0 0 12-12v-36h36a12 12 0 0 0 12-12V40a12 12 0 0 0-12-12m-60 176H52V100h104Zm48-48h-24V88a12 12 0 0 0-12-12h-68V52h104Z"/>
      </svg>
      <span>{{ loading() ? 'Lädt…' : 'Link kopieren' }}</span>
    </button>

    <button (click)="openResetConfirm()" [disabled]="loading()"
            class="inline-flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium text-red-700 bg-red-50 transition-all duration-200 hover:bg-red-100 active:scale-95 disabled:cursor-not-allowed disabled:opacity-50"
            data-testid="calendar-reset-link" type="button">
      <svg class="h-4 w-4" height="16" viewBox="0 0 256 256" width="16" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path
          d="M197.67 186.37a94 94 0 1 1 .12-116.85 8 8 0 1 1-12.6 9.86A78 78 0 1 0 185 176a8 8 0 0 1 11.32-.32ZM224 40a8 8 0 0 0-8 8v40a8 8 0 0 1-8 8h-40a8 8 0 0 1 0-16h21.38A87.72 87.72 0 0 0 128 48a8 8 0 0 1 0-16 96 96 0 0 1 88 57.63V48a8 8 0 0 1 8-8Z"/>
      </svg>
      <span>Link zurücksetzen</span>
    </button>
  </div>

  @if (resetConfirmOpen()) {
    <!-- Backdrop click cancels: a reset that hasn't been confirmed yet costs nothing, same as the style guide's
         "Destructive-confirmation dialog" pattern. -->
    <div (click)="cancelReset()"
         class="fixed inset-0 z-[1100] flex items-end justify-center bg-black/40 p-0 sm:items-center sm:p-4">
      <div (click)="$event.stopPropagation()" aria-describedby="calendar-reset-body"
           aria-labelledby="calendar-reset-heading" aria-modal="true" role="alertdialog"
           class="w-full max-h-[90vh] overflow-y-auto rounded-t-2xl bg-white shadow-xl sm:max-w-lg sm:rounded-2xl"
           data-testid="calendar-reset-confirm">
        <div class="space-y-4 p-4 sm:p-6">
          <h2 class="text-xl font-bold tracking-tight text-gray-900" id="calendar-reset-heading">
            Kalenderlink zurücksetzen?
          </h2>

          <div class="space-y-3 text-sm text-gray-700" id="calendar-reset-body">
            <p>
              Der bisherige Kalenderlink funktioniert danach nicht mehr. Jede Kalender-App, in der Sie ihn
              eingerichtet haben, erhält dann keine Aktualisierungen mehr.
            </p>
            <p class="rounded-2xl bg-red-50 px-4 py-3 font-semibold text-red-700" role="alert">
              Bitte abonnieren Sie den Kalender in jeder dieser Kalender-Apps erneut mit dem neuen Link.
            </p>
          </div>

          <div class="flex justify-end gap-3 border-t border-gray-100 pt-4">
            <button #cancelButton (click)="cancelReset()"
                    class="inline-flex items-center justify-center rounded-2xl border border-gray-200 px-4 py-2.5 text-sm font-semibold text-gray-600 shadow-sm transition-all duration-200 hover:border-gray-300 hover:bg-gray-50 active:scale-95"
                    data-testid="calendar-reset-confirm-cancel" type="button">
              Abbrechen
            </button>
            <button (click)="confirmReset()" [disabled]="resetBusy()"
                    class="inline-flex items-center justify-center rounded-2xl bg-red-600 px-5 py-2.5 text-sm font-semibold text-white shadow-lg shadow-red-100 transition-all duration-200 hover:bg-red-700 hover:shadow-xl active:scale-95 disabled:cursor-not-allowed disabled:opacity-30 disabled:grayscale"
                    data-testid="calendar-reset-confirm-submit" type="button">
              @if (resetBusy()) {
                Wird zurückgesetzt…
              } @else {
                Ja, zurücksetzen
              }
            </button>
          </div>
        </div>
      </div>
    </div>
  }
</div>
